import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {api} from '@/lib/api'
import type {components} from '@/lib/api-schema'

export type Constructor = components['schemas']['ConstructorRead']
export type ConstruirPayload = components['schemas']['ConstruirPayload']
export type ConstruirResult = components['schemas']['ConstruirResult']
export type ConstructorCatalogo = components['schemas']['ConstructorCatalogoRead']

// Espejo de los códigos con generador del catálogo backend (`sgsst_constructores.py`): estático
// porque es pequeño y estable y no vale un round-trip por fila.
export const CONSTRUCTOR_CTA_CODES = new Set(['2.6.1', '4.2.6', '3.1.7'])

export function useConstructor(businessId: string | undefined, code: string, enabled: boolean) {
  return useQuery({
    queryKey: ['constructor', businessId, code],
    queryFn: async () => (await api.get<Constructor>(`/businesses/${businessId}/sgsst/constructores/${code}`)).data,
    enabled: !!businessId && enabled,
  })
}

export function useConstructoresCatalogo(businessId: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: ['constructores-catalogo', businessId],
    queryFn: async () => (await api.get<ConstructorCatalogo[]>(`/businesses/${businessId}/sgsst/constructores`)).data,
    enabled: !!businessId && enabled,
  })
}

export function useConstruir(businessId: string | undefined, code: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (payload: ConstruirPayload) =>
      (await api.post<ConstruirResult>(`/businesses/${businessId}/sgsst/constructores/${code}/construir`, payload))
        .data,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['sgsst', businessId]})
      queryClient.invalidateQueries({queryKey: ['evidence', businessId]})
      queryClient.invalidateQueries({queryKey: ['sgsst-pendientes', businessId]})
      queryClient.invalidateQueries({queryKey: ['constructor', businessId, code]})
    },
  })
}
